import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useUIStore } from "../store";
import { Product } from "../interfaces/domain/menu";

export const useMainPlate = (plate: Product) => {
  const navigate = useNavigate();
  const setSection = useUIStore((s) => s.setSection);

  const openModal = useCallback(() => {
    setSection("productModal");

    const params = new URLSearchParams(window.location.search);

    params.set("product", plate.id);
    params.set("title", plate.title ?? "");
    params.set("price", String(plate.price ?? ""));

    navigate(`?${params.toString()}`);
  }, [navigate, plate, setSection]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      openModal();
    }
  }, [openModal]);

  return {
    openModal,
    handleKeyDown,
  };
};